import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "./theme/ThemeProvider";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Admin from "./pages/admin/Admin";
import { legacyRedirects } from "./content/posts";
import "./styles/index.scss";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/hizmetler" exact component={Services} />
          <Route path="/hizmetler/:slug" exact component={ServiceDetail} />
          <Route path="/hakkimizda" exact component={About} />
          <Route path="/blog" exact component={Blog} />
          <Route path="/blog/:slug" exact component={BlogPost} />
          <Route path="/iletisim" exact component={Contact} />
          <Route path="/admin" exact component={Admin} />
          {Object.entries(legacyRedirects).map(([from, to]) => (
            <Redirect key={from} from={from} to={to} exact />
          ))}
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
